import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-input-colum-filter-certificate',
  templateUrl: './input-colum-filter-certificate.component.html',
  styleUrls: ['./input-colum-filter-certificate.component.scss']
})
export class InputColumFilterCertificateComponent implements OnInit {

  filterText = '';
  columnToFilter: string;

  filter = '';

  disabled = true;
  params: any;
  valueGetter: any;

  constructor() {
  }

  ngOnInit() {
  }

  agInit(params: any): void {
    this.params = params;
    this.columnToFilter = params.colDef.field;
  }

  isFilterActive() {
    return this.disabled !== false;
  }

  doesFilterPass(params): boolean {
    const value = this.params.valueGetter(params.node);
    return value.toLowerCase().includes(this.filterText.toLowerCase());
  }

  getModel() {
    return {filter: this.filter};
  }

  setModel(model) {
    this.filter = model ? model.filter : '';
  }

}
